import { c as _c } from "react/compiler-runtime";
import { gql, useQuery } from '@material-bank/graphql-client';
export type BrandRepQueryData = {
  brandRep: {
    firstName: string;
    lastName: string;
    photo: string | null;
    email: string;
    phone: string | null;
  } | null;
};
export type BrandRepQueryVars = {
  tagRef: string;
  sku?: string;
};
const brandRepQuery = gql`
  query BrandRep($tagRef: String!, $sku: String) {
    brandRep(tagRef: $tagRef, sku: $sku) {
      firstName
      lastName
      photo
      email
      phone
    }
  }
`;
export function useBrandRepQuery(options) {
  const $ = _c(4);
  const {
    data,
    error,
    loading
  } = useQuery(brandRepQuery, options);
  const t0 = data?.brandRep;
  let t1;
  if ($[0] !== error || $[1] !== loading || $[2] !== t0) {
    t1 = {
      data: t0,
      error,
      loading
    };
    $[0] = error;
    $[1] = loading;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}